import { merge, gt, sum, subtract } from "@/utils/helpers.js";
import { getProfit } from "./utils";
import { floatAdd, floatMul } from "@/utils/num";


// helpers
import { validate } from "@/libs/veeValidate";
// 散卖基类
export default class _MixinBulk {
  constructor(props) {
    merge(
      this,
      {
        spd_id: 0, //航期ID
        cabin_id: 0, //舱房ID
        cabin_name: "标准阳台房", //舱型名称
        min_people: 2, //最小入住人数
        max_people: 2, //最大入住人数
        bed_num: 1, //加床数
        room34_num: 0, //34人间数
        last_stock: 0, //剩余间数
        best_adult: 1, //最优成人数
        max_adult: 1, //最大成人数
        is_share: 1, // 是否分房
        prices: {
          th: {
            sps_id: 475, //航期id
            type: 2, //类别 1-成本 2-同行 3-零售
            adult_price: 3, //成人价
            child_price: 3, //儿童价
            adult34_price: 0, //海轮34儿童价格
            child34_price: 0, //海轮34成人价格
            adult_bed_price: 0, //成人加床价
            child_bed_price: 0, //儿童加床价
            child_no_bed_price: 0, //儿童不占床价
            diff_room_price: 3 //单房差价
          },
          sale: {
            sps_id: 475,
            type: 3,
            adult_price: 4,
            child_price: 4,
            adult34_price: 0,
            child34_price: 0,
            adult_bed_price: 0,
            child_bed_price: 0,
            child_no_bed_price: 0,
            diff_room_price: 4
          }
        }
      },
      props
    );

    this.hasDiffRoomPrice = props.prices.th.diff_room_price > 0;
    this.canChildNoBed = props.prices.th.child_no_bed_price > 0; // 儿童能否不占床
    this.canChildBed = props.prices.th.child_bed_price > 0; // 能否儿童加床

    this._adultNum = 0; // 成人数量
    this._adultBedNum = 0; // 成人加床

    this._childNum = 0; // 儿童数量
    this._childBedNum = 0; // 儿童加床
    this._maxChildBedNum = 0; // 最大儿童加床数量
    this._roomNum = 0; // 房间数
    this._maxRoomNum = 1; // 最大可选房间数
    this._maxChildNum = 0; // 最大儿童数量

    // 验证
    this.validResult = {
      valid: true
    };
  }
  get totalPeople() {
    return sum([this.adultNum, this.childNum]);
  }
  get messages() {
    if (Math.floor(this.roomNum) !== this.roomNum) {
      return "当前有1间房为拼房";
    }

    // let hasDiffRoomPrice = !!this.prices.th.diff_room_price;
    // let {roomNum} = this;
    // let peopleNum = this.adultNum + this.childNum;
    // if (!this.hasDiffRoomPrice && peopleNum < this.min_people * this.roomNum) {
    //   return `每间舱房必须入住${this.min_people}人，请重新选择`;
    // }
    return "";
  }
  async validate() {
    let min_people = this.hasDiffRoomPrice
      ? this.min_people - 1
      : this.min_people;
    min_people = min_people <= 0 ? 1 : min_people;
    let min_value = floatMul(this._roomNum, min_people);
    let total_people = this.adultNum + this.childNum;
    const customMessages = {
      min_value: `每间舱房最少入住${this.min_people}人,请重新选择`
    };
    this.validResult = await validate(
      total_people,
      { min_value },
      { customMessages }
    );
  }

  // 最大儿童数
  get maxChildNum() {
    return this._maxChildNum;
  }
  // 入住人数/最少入住人数（内河每间最少入住成人数为1）
  get maxRoomNum() {
    return this._maxRoomNum;
  }
  // 最大儿童可加床数量
  get maxChildBedNum() {
    return this._maxChildBedNum;
  }
  get totalPriceList() {
    // 成人同行总计 = 成人同行价 * （成人数量 - 成人加床数）
    let adultNum = subtract(this.adultNum, this.adultBedNum);
    let totalAdultPrice = floatMul(adultNum, this.prices.th.adult_price);
    /**
     * 成人利润 = （成人数量 - 成人加床数）* （销售成人 - 同行成人）
     */
    let totalAdultProfit = getProfit(
      this.prices.th.adult_price,
      this.prices.sale.adult_price,
      subtract(this.adultNum, this.adultBedNum)
    );
    let totalAdultBedPrice = floatMul(
      this.adultBedNum,
      this.prices.th.adult_bed_price
    );
    let totalAdultBedProfit = getProfit(
      this.prices.th.adult_bed_price,
      this.prices.sale.adult_bed_price,
      this.adultBedNum
    );
    // console.log({
    //   childNotBedNum: this.childNotBedNum,
    //   childBedNum: this.childBedNum
    // })
    // 占床儿童数量
    let childNum = [this.childNotBedNum, this.childBedNum].reduce(
      subtract,
      this.childNum
    );

    // let hasBedChildNum = this.childNum - this.childNotBedNum - this.childBedNum;
    // 儿童销售总价
    let totalChildPrice = floatMul(childNum, this.prices.th.child_price);
    /**
     * 儿童利润 = （儿童数量 - 儿童加床数 - 儿童不占床）* （销售儿童 - 同行儿童）
     */
    let totalChildProfit = getProfit(
      this.prices.th.child_price,
      this.prices.sale.child_price,
      childNum
    );

    /**
     * 儿童不占床 = 儿童不占床价格 * 儿童不占床数量
     */
    let totalChildNotBedPrice = floatMul(
      this.childNotBedNum,
      this.prices.th.child_no_bed_price
    );
    /**
     * 儿童不占床利润
     */
    let totalChildNotBedProfit = getProfit(
      this.prices.th.child_no_bed_price,
      this.prices.sale.child_no_bed_price,
      this.childNotBedNum
    );
    // 儿童加床价格
    let totalChildBedPrice = floatMul(
      this.childBedNum,
      this.prices.th.child_bed_price
    );
    /**
     * 儿童加床利润
     */
    let totalChildBedProfit = getProfit(
      this.prices.th.child_bed_price,
      this.prices.sale.child_bed_price,
      this.childBedNum
    );

    // 单房差总价 = 单房差数量 * 单房差价格
    let totalDiffRoomPrice = floatMul(
      this.prices.th.diff_room_price,
      this.diffRoomPriceNum
    );
    // 单房差利润 = 单房差数量 * （单方差销售价 - 单房差同行价）
    let totalDiffRoomPriceProfit = getProfit(
      this.prices.th.diff_room_price,
      this.prices.sale.diff_room_price,
      this.diffRoomPriceNum
    );
    return [
      {
        title: "成人价格",
        num: adultNum,
        totalPrice: totalAdultPrice,
        profit: totalAdultProfit
      },
      {
        title: "儿童价格",
        num: childNum,
        totalPrice: gt(childNum, 0) ? totalChildPrice : 0,
        profit: totalChildProfit
      },
      {
        title: "儿童不占床价格",
        num: this.childNotBedNum,
        totalPrice: totalChildNotBedPrice,
        profit: totalChildNotBedProfit
      },
      {
        title: "加床儿童价格",
        num: this.childBedNum,
        totalPrice: totalChildBedPrice,
        profit: totalChildBedProfit
      },
      {
        title: "加床成人价格",
        num: this.adultBedNum,
        totalPrice: totalAdultBedPrice,
        profit: totalAdultBedProfit
      },
      {
        title: "单房差",
        num: this.diffRoomPriceNum,
        totalPrice: !this.hasDiffRoomPrice ? 0 : totalDiffRoomPrice,
        profit: !this.hasDiffRoomPrice ? 0 : totalDiffRoomPriceProfit
      }
    ].filter(row => row.num > 0);
  }

  get totalPrice() {
    // const totalPriceList = this.totalPriceList.reduce(row => row.totalPrice)
    return this.totalPriceList.reduce((total, curr) => floatAdd(total, curr.totalPrice), 0)

    // const ret = totalPriceList.reduce((total, curr) => floatAdd(total, curr), 0)
    // return ret

    // return floatAdd((total, curr) => floatAdd(total, curr), 0);
  }

  get totalProfit() {
    // return sum(this.totalPriceList.map(row => row.profit));
    return this.totalPriceList.reduce((total, curr) => floatAdd(total, curr.profit), 0)

    // const totalPriceList = this.totalPriceList.map(row => row.profit)
    // const ret =  totalPriceList.reduce((total, curr) => floatAdd(total, curr), 0)
    // return ret


  }
}
